/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
const { RequestCommand } = require('./RequestCommands');
const JSGSelectCellsCommand = require('../SelectCellsCommand');

class SelectCellsCommand extends RequestCommand {
	constructor(sheet, graph, selectedCells) {
		super(sheet);
		const sheetId = sheet.model.id;
		const selectionId = sheet.getSelectionId();
		this.isVolatile = true;
		// create original cmd:
		this.selectcmd = new JSGSelectCellsCommand(graph, sheetId, selectionId, selectedCells);
	}

	getExecuteRequest() {
		this.selectcmd.execute();
		const json = this.selectcmd.toObject();
		return this.createRequest(json.data);
	}
	getRedoRequest() {}
	getUndoRequest() {}
	handleResult() {}
}
module.exports = SelectCellsCommand;
